import config from "config";
import { APICore } from "helpers/api/apiCore";

const api = new APICore();
function createExcessMoneyRefundApi(params: any) {
    const apiData = {
        repaymentExcessMoneyId: params?.repaymentExcessMoneyId,
        refundAmount: params?.refundAmount,
        refundAccountNumber: params?.refundAccountNumber,
        refundIfscCode: params?.refundIfscCode,
        makerRemarks: params?.makerRemarks
    }

    const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-excess-money/refund`
    return api.create(`${baseUrl}`, apiData)
}

function approveExcessMoneyRefundApi(params: any) {
    const apiData = {
        checkerRemarks: params?.values?.checkerRemarks
    }
 
    const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-excess-money/refund/${params.id}/approve`
   
    return api.updatePatch(`${baseUrl}`, apiData)
}

function rejectExcessMoneyRefundApi(params: any) {
    const apiData = {
        checkerRemarks: params?.values?.checkerRemarks
    }

    const baseUrl = `${config.REPAYMENT_BASE_URL}/repayment-excess-money/refund/${params.id}/reject`
    
    return api.updatePatch(`${baseUrl}`, apiData)
}
export { createExcessMoneyRefundApi, approveExcessMoneyRefundApi, rejectExcessMoneyRefundApi }